


export const FETCH_TAX_REQUEST = "FETCH_TAX_REQUEST";
export const FETCH_TAX_SUCCESS = "FETCH_TAX_SUCCESS";
export const FETCH_TAX_FAILURE = "FETCH_TAX_FAILURE";

export const CREATE_TAX_REQUEST = "CREATE_TAX_REQUEST";
export const CREATE_TAX_SUCCESS = "CREATE_TAX_SUCCESS";
export const CREATE_TAX_FAILURE = "CREATE_TAX_FAILURE";

export const UPDATE_TAX_REQUEST = "UPDATE_TAX_REQUEST";
export const UPDATE_TAX_SUCCESS = "UPDATE_TAX_SUCCESS";
export const UPDATE_TAX_FAILURE = "UPDATE_TAX_FAILURE";